import { render, staticRenderFns } from "./decorate.vue?vue&type=template&id=bfdb83e4&"
import script from "./decorate.vue?vue&type=script&lang=js&"
export * from "./decorate.vue?vue&type=script&lang=js&"
import style0 from "./decorate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports